import { compose } from 'recompose';
import { connect } from 'react-redux';

import StageEstimatedTime from './component';

import { getETAData } from 'redux/modules/journey-stops/selectors';

const enhance = compose(
  connect((state, props) => {
    const { journeyId } = props;

    const ETAData = getETAData(state, journeyId);

    if (!ETAData) {
      return {};
    }

    const { retrieved_time, travel_time } = ETAData;

    return {
      travelTime: travel_time,
      retrievedTime: retrieved_time,
    };
  })
);

export default enhance(StageEstimatedTime);
